import React from 'react'
import { withScriptjs, withGoogleMap, GoogleMap, Marker } from 'react-google-maps'

const Map = withScriptjs(withGoogleMap(props =>
  <GoogleMap
    defaultZoom={9}
    defaultCenter={{
      lat: props.placedMarker[0].latitude,
      lng: props.placedMarker[0].longitude
    }}
    onClick={e => props.getLocation(e.latLng.lat(), e.latLng.lng())}
    options={{ gestureHandling: "greedy" }}
  >
    {props.placedMarker.map((x) =>
      <Marker
        key={x.id}
        position={{ lat: x.latitude, lng: x.longitude }}
      >
      </Marker>
    )}
  </GoogleMap>
));

export default Map;

